import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faq';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="defer-paint w-full bg-ink py-12 sm:py-14" aria-labelledby="faq-heading" data-id="element-48" data-mp="1bl23p9e8x8f0">
      <div className="mx-auto max-w-3xl px-6" data-id="element-49" data-mp="1gj3mdt7rf5py">
        <div className="text-center" data-id="element-50" data-mp="1gjvjj8h09bic">
          <p className="eyebrow text-gold" data-id="element-51" data-mp="249g3nuowaet7">Antes de decidir</p>
          <h2 id="faq-heading" className="mt-4 font-display text-[2rem] font-bold leading-[1.1] text-ivory sm:text-4xl" data-id="element-52" data-mp="249zl7aamv16p">
            Preguntas frecuentes
          </h2>
        </div>

        <ul className="mt-10 space-y-2.5" data-id="element-53" data-mp="1uildif8j2v2h">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className={`rounded-3xl border bg-coal transition-colors duration-150 ease-out ${isOpen ? 'border-gold/45' : 'border-line'}`} data-id="element-54" data-mp="1zg4v9p4fppz6" data-mpi={index}>
                <h3 data-id="element-55" data-mp="2s0br6fmbinun">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 rounded-3xl px-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold" data-id="element-56" data-mp="2s0v93wbyxc8o">
                    <span className="font-display text-lg font-bold leading-snug text-ivory sm:text-xl" data-id="element-57" data-mp="19u51njp13lvz">
                      {faq.question}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-gold bg-gold text-ink' : 'border-gold/35 bg-gold/10 text-gold'}`} aria-hidden="true" data-id="element-58" data-mp="1jk6s2i4utge2">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-59" data-mp="1sm68b881ogfy" />
                    </span>
                  </button>
                </h3>

                <div id={`faq-panel-${index}`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-60" data-mp="3udj9bm6w646q">
                  <div className="overflow-hidden" data-id="element-61" data-mp="238pvmsd76ik7">
                    <p className="px-6 pb-6 font-sans text-[0.92rem] leading-relaxed text-stone" data-id="element-62" data-mp="287iy7pqy4p5l">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}